import React, { FC } from "react";
import { Helmet } from "react-helmet";
import { Location } from "@reach/router";
import { HelmetHeaderProps } from "../types";

const headerData = [
  {
    title: 'Why we built Hexowatch',
    description: 'In this special four part series we go tactical and look at how you can benefit from the same strategies used by Fortune 500 companies, Google, Amazon and even the military, to monitor your competition and stay ahead of the game.',
    path: '/about',
  },
  {
    title: 'Customer support contacts | Hexowatch',
    description: 'Customer support contacts - content change detection and alerting solution',
    path: '/contact'
  },
  {
    title: 'Cookie Policy - content change detection and alerting solution',
    description: 'This Cookie Policy describes how and why HEXACT use cookies',
    path: '/cookie-policy'
  },
  {
    title: 'Hexowatch FAQ',
    description: 'In this page you can get the answers to FAQs',
    path: '/faq',
  },
  {
    title: 'Hexowatch - forgot password',
    description: '',
    path: '/forgot-password'
  },
  {
    title: 'Login page | Hexowatch',
    description: 'The page to login to your account at Hexowatch.com',
    path: '/login'
  },
  {
    title: 'Media Kit | Hexowatch logo and colors',
    description: 'We share guidelines to help our customers use Hexowatch logo and colors without having to negotiate legal agreements',
    path: '/media-kit',
  },
  {
    title: 'Hexowatch Integration with Pabbly',
    description: 'Get events from Hexwatch directly to your environment using Pabbly',
    path: '/pabbly'
  },
  {
    title: 'Content change detection and alerting solution Pricing packages',
    description: 'Hexowatch is your AI sidekick to monitor any website for visual, content, source code or data changes',
    path: '/pricing'
  },
  {
    title: 'Privacy Policy - content change detection and alerting solution',
    description: 'Your privacy is very important to us and we have created this privacy statement in order to demonstrate our commitment to you.',
    path: '/privacy-policy'
  },
  {
    title: 'Registration page | Hexowatch',
    description: 'Register your free account and get full access to the website tools.',
    path: '/registration'
  },
  {
    title: 'Hexowatch - reset password',
    description: '',
    path: '/reset-password'
  },
  {
    title: 'Public Roadmap and Development Plans',
    description: 'This roadmap describes Hexowatch platform development plans for the benefit of its customers and users.',
    path: '/roadmap'
  },
  {
    title: 'Get Monitoring Events in Slack',
    description: 'Connect with Slack to receive the monitoring notifications about your detected events.',
    path: '/slackbot'
  },
  {
    title: 'Software Integrations',
    description: 'List of 3rd party integrations with Hexowatch',
    path: '/software-integrations'
  },
  {
    title: 'Get Monitoring Events in Telegram',
    description: 'Connect with Telegram to receive the monitoring notifications about your detected events.',
    path: '/telegrambot'
  },
  {
    title: 'Terms of Service - content change detection and alerting solution',
    description: 'These Terms of Service contain an Arbitration Agreement that may impact your rights to use the courts to resolve disputes.',
    path: '/terms-of-use'
  },
  {
    title: 'Hexowatch - verify email',
    description: '',
    path: '/verify-email'
  },
  {
    title: 'API Documentation',
    description: 'This page provides documentation to get API keys for monitored URLs.',
    path: '/api-documentation'
  },
  {
    title: 'Hexowatch Integration with Zapier',
    description: 'Get events from Hexwatch directly to your environment using Zapier',
    path: '/zapier'
  },

  {
    title: 'Hexowatch use cases',
    description: '',
    path: '/use-cases'
  },
  {
    title: 'Monitor your website for security threats',
    description: '',
    path: '/use-cases/monitor-website-security-threads'
  },
  {
    title: 'Monitor your competitors',
    description: '',
    path: '/use-cases/monitor-competitors'
  },
  {
    title: 'Find out when websites publish new requests for proposals & be the first to respond to RFP Alerts',
    description: '',
    path: '/use-cases/monitor-requests-for-proposals'
  },
  {
    title: 'Receive alerts when products become available or go out of stock',
    description: '',
    path: '/use-cases/monitor-products-availability'
  },
  {
    title: 'Monitor pages for legal & corporate compliance',
    description: '',
    path: '/use-cases/monitor-legal-compliance'
  },
  {
    title: 'Monitor Press Mentions',
    description: '',
    path: '/use-cases/monitor-press-mentions'
  },
  {
    title: 'Tracking changes on websites',
    description: '',
    path: '/use-cases/track-page-changes'
  },
  {
    title: 'Financial services compliance monitoring',
    description: '',
    path: '/use-cases/financial-compliance-monitoring'
  },
  {
    title: 'Receive alerts when event tickets go on sale',
    description: '',
    path: '/use-cases/know-when-event-tickets-sale'
  },
  {
    title: 'How to use Hexowatch',
    description: 'walkthrough videos that explain how to setup all our different monitor types.',
    path: '/how-to-use-hexowatch'
  },
   // monitorings
  {
    title: 'Visual monitoring',
    description: 'Monitor web pages for any visual changes. Select a part of the screen or the whole page.',
    path: '/visual-monitoring'
  },
  {
    title: 'HTML element monitoring',
    description: 'Monitor specific HTML elements or the content of any field for changes.',
    path: '/html-element-monitoring'
  },
  {
    title: 'Keyword monitoring',
    description: 'Monitor web pages for the presence or absence of specific keywords.',
    path: '/keyword-monitoring'
  },
  {
    title: 'Technology monitoring',
    description: 'Monitor changes to the tech stack or 3rd party scripts used on the web page.',
    path: '/technology-monitoring'
  },
  {
    title: 'HTML monitoring',
    description: 'Monitor web pages for any source code/HTML modifications.',
    path: '/html-monitoring'
  },
  {
    title: 'Content monitoring',
    description: 'Monitor the visible content on a web page for any changes.',
    path: '/content-monitoring'
  },
  {
    title: 'Automatic AI monitoring',
    description: 'Hexowatch will look for any types of changes (visual, content, HTML and technology monitoring).',
    path: '/automatic-ai-monitoring'
  },
  {
    title: 'Availability monitoring',
    description: 'Monitor any URL for downtime, and get alerts when a web page goes down.',
    path: '/availability-monitoring'
  },
  {
    title: 'Domain WHOIS monitoring',
    description: 'Monitor the ownership and administrative records of the domain names.',
    path: '/domain-whois-monitoring'
  },
  {
    title: '',
    description: '',
    path: '/home'
  },
  {
    title: '',
    description: '',
    path: '/404'
  },
  {
    title: 'Hexowatch - content change detection and alerting solution',
    description: 'Hexowatch is your AI sidekick to monitor any website for visual, content, source code or data changes',
    path: '/'
  },
];

export default ({ }: FC<HelmetHeaderProps>) => {
  return (
    <Location>
      {({ location }) => {
        const item = headerData.find(data => {
          if (location.pathname[location.pathname.length - 1] === '/' && location.pathname !== '/') {
            return data.path === location.pathname.substr(0, location.pathname.length - 1);
          } else if (location.pathname === '/') {
            return data.path === location.pathname;
          } else {
            return location.pathname === data.path || location.pathname === data.path + '/';
          }
        })
        return (
          item && <Helmet
            key={item.title}
            link={[
              {
                rel: "canonical",
                href: `https://hexowatch.com${location.pathname}`,
              },
            ]}
            title={item.title}
            meta={[
              { name: 'description', content: item.description },
              { property: 'og:image', content: 'https://hexowatch.com/Hexowatch-AI-sidekick.png' },
              { property: 'og:url', content: `https://hexowatch.com${location.pathname}` },
              { property: 'og:title', content: item.title },
              { property: 'og:description', content: item.description },
              { property: 'og:type', content: 'website' },
              { property: 'og:locale', content: 'en_US' },
              { name: 'twitter:image', content: 'https://hexowatch.com/Hexowatch-AI-sidekick.png' },
              { name: 'twitter:title', content: item.title },
              { name: 'twitter:description', content: item.description },
              { name: 'twitter:card', content: 'summary_large_image' },
              { name: 'twitter:site', content: '@hexactinc' },
            ]}
          >
            <html lang="en" />
          </Helmet>
        );
      }}
    </Location>
  );
};
